import { FC } from "react";
import {
  Blocks,
  BuilderBlock,
  BuilderContextInterface,
  RegisteredComponents,
} from "@builder.io/sdk-react";
import ChromelessHeader from "@/components/ChromelessHeader/ChromelessHeader";
import { Theme } from "@/types";
import { BuilderProps } from "@/types/builder/BuilderProps";
import { Link as LinkProps } from "@/types/General/Link";

type ChromelessHeaderBlockProps = {
  logo?: BuilderBlock[];
  link?: LinkProps;
  theme?: Theme | "cool-gray";
  icon?: BuilderBlock[];
  builderBlock: BuilderBlock;
  builderComponents: RegisteredComponents;
  builderLinkComponent: unknown;
  builderContext: BuilderContextInterface;
} & BuilderProps;

export const ChromelessHeaderBlock: FC<ChromelessHeaderBlockProps> = ({
  logo,
  theme,
  link,
  icon,
  builderBlock,
  builderComponents,
  builderLinkComponent,
  builderContext,
}) => {
  return (
    <ChromelessHeader
      link={link}
      logo={
        logo ? (
          <Blocks
            parent={builderBlock?.id}
            blocks={logo}
            path="logo"
            registeredComponents={builderComponents}
            linkComponent={builderLinkComponent}
            context={builderContext}
          />
        ) : undefined
      }
      icon={
        icon ? (
          <Blocks
            parent={builderBlock?.id}
            blocks={icon}
            path="icon"
            registeredComponents={builderComponents}
            linkComponent={builderLinkComponent}
            context={builderContext}
          />
        ) : undefined
      }
      theme={theme}
    />
  );
};
